import { LuPlus } from "react-icons/lu";
import Button from "../../../../../components/buttons/button";
import RiyalIcon from "../../../../../icons/riyalIcon";
import { IoEyeOutline } from "react-icons/io5";
import Table from "../../../../../components/table/table";
import { useState } from "react";
import Popup from "../../../../../components/popups/popup";
import EntitlementSearch from "./entitlementSearch";
import EntitlementAdd from "./entitlementAdd";
import EntitlementDetails from "./entitlementDetails";

const EntitlementsTab = ({ t }) => {
  const [openView, setOpenView] = useState(false);
  const [openAdd, setOpenAdd] = useState(false);
  const financialEntitlements = [
    {
      id: 1,
      employee: "هشام المدير عبدالله العمري",
      type: "مكافاة",
      reason: "إنجاز مشروع قبل الموعد",
      amount: "3,500",
      date: "15 يونيو 2025",
      status: "تم الموافقة",
    },
    {
      id: 2,
      employee: "هشام المدير عبدالله العمري",
      type: "مكافاة",
      reason: "إنجاز مشروع قبل الموعد",
      amount: "3,500",
      date: "15 يونيو 2025",
      status: "تم الموافقة",
    },
    {
      id: 3,
      employee: "هشام المدير عبدالله العمري",
      type: "خصم",
      reason: "تأخر متكرر",
      amount: "500",
      date: "15 يونيو 2025",
      status: "تم الموافقة",
    },
    {
      id: 4,
      employee: "هشام المدير عبدالله العمري",
      type: "سلفة",
      reason: "سلفة شخصية",
      amount: "2000",
      date: "5 يونيو 2025",
      status: "تم الموافقة",
    },
    {
      id: 5,
      employee: "هشام المدير عبدالله العمري",
      type: "سلفة",
      reason: "سلفة شخصية",
      amount: "2000",
      date: "5 يونيو 2025",
      status: "مراجع",
    },
  ];

  const tableHead = [
    {
      header: "id",
      accessorKey: "id",
    },
    {
      header: t("employee"),
      accessorKey: "employee",
    },
    {
      header: t("type"),
      accessorKey: "type",
    },
    {
      header: t("reason"),
      accessorKey: "reason",
    },
    {
      header: t("amount"),
      accessorKey: "amount",
    },
    {
      header: t("date"),
      accessorKey: "date",
    },
    {
      header: t("status"),
      accessorKey: "status",
    },

    {
      header: t("actions"),
      accessorKey: "actions",
    },
  ];
  const tableData = financialEntitlements.map((m, i) => {
    const statusColor = m.status === "تم الموافقة" ? "#E6F4EF" : "#FFEBCA";
    const statusTextColor = m.status === "تم الموافقة" ? "#11A849" : "#F59E0B";
    const typeColor =
      m.type === "مكافاة" ? "#E6EDF4" : m.type === "خصم" ? "#F4E6E6" : "#EBE6F4";
    const typeTextColor =
      m.type === "مكافاة" ? "#3872FA" : m.type === "خصم" ? "#C42E27" : "#9A27C4";
    const status = (
      <span
        style={{ backgroundColor: statusColor, color: statusTextColor }}
        className="block w-full px-2 py-1 rounded-lg"
      >
        {t(m.status)}
      </span>
    );
    const type = (
      <span
        style={{ backgroundColor: typeColor, color: typeTextColor }}
        className="block w-full px-2 py-1 rounded-lg"
      >
        {t(m.type)}
      </span>
    );

    const amount = (
      <span className="flex items-center justify-center">
        {m.amount}
        <RiyalIcon fill={"white"} className={"size-6"} />
      </span>
    );

    const actions = (
      <div onClick={() => setOpenView(true)} className="mx-auto cursor-pointer w-fit">
        <IoEyeOutline size={24} />
      </div>
    );
    return {
      id: m.id,
      employee: m.employee,
      amount,
      type,
      date: m.date,
      reason: m.reason,
      status,
      actions,
    };
  });
  return (
    <div className="grid">
      <div className="flex flex-wrap items-center justify-between md:flex-nowrap">
        <h2 className="text-lg font-bold capitalize">
          {t("financialEntitlementDetails")}
        </h2>
        <Button
          onClick={() => setOpenAdd(true)}
          type={"button"}
          className={"flex items-center rounded-lg gap-2 bg-[#1E4071]"}
        >
          <LuPlus size={20} className="text-white" />

          {t("addNewEntitlement")}
        </Button>
      </div>
      <EntitlementSearch t={t} />
      <Table TableData={tableData} TableHead={tableHead} />

      <Popup open={openAdd} setOpen={setOpenAdd} header={t("addNewEntitlement")}>
        <EntitlementAdd t={t} setOpen={setOpenAdd} />
      </Popup>
      <Popup open={openView} setOpen={setOpenView} header={t("details")}>
        <EntitlementDetails t={t} />
      </Popup>
    </div>
  );
};

export default EntitlementsTab;
